import * as z from 'zod';
export const PriceSchema = z.object({
    amount: z.number().int().min(0),
    currency: z.string(),
});
